import React, { useState } from 'react'
import * as S from './IEVersion.styles'
import { useIntl } from 'gatsby-plugin-intl'
import copy from "copy-to-clipboard";  

const IEVersion = () => {
  const { formatMessage } = useIntl()
  const [copyText, setCopyText] = useState('https://vpsvale.com');
  
  const copyToClipboard = () => {
    copy(copyText);
  }

  return (
    <S.IEVersion>
      <S.Wrapper>
        <S.Content>
          <S.Ops>{formatMessage({ id: 'IEVersion.ops' })}</S.Ops>
          <S.Title>{formatMessage({ id: 'IEVersion.title' })}</S.Title>
          <S.Description>{formatMessage({ id: 'IEVersion.description-1' })}<br />{formatMessage({ id: 'IEVersion.description-2' })}</S.Description>
          <S.LinkWrapper>
            <S.Field type="text" value={copyText} disabled />
            <S.Button onClick={copyToClipboard}>{formatMessage({ id: 'IEVersion.button' })}</S.Button>
          </S.LinkWrapper>
        </S.Content>
      </S.Wrapper>
    </S.IEVersion>
  )
}

export default IEVersion
